<template>
  <div class="about">
    <h1>This is an withdraw page</h1>
  </div>
</template>
